import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    validationStarted: (fileCount: number) => string | React.ReactNode;
    unsupportedSkipped: (skippedCount: number) => string | React.ReactNode;
    tooManySelectedText: string;
    errorStartingText: string;
    noSupportedFilesText: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Success toast message when UBS validation starts; pluralized by file count. */
            validationStarted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (fileCount: number) => __intl__.intl().formatMessage({ id: "useUbsValidationAction.validationStarted?c=337zepuu4m7kp", defaultMessage: "{fileCount, plural, one {UBS validation started for {fileCount} file.} other {UBS validation started for {fileCount} files.}}" }, { fileCount: fileCount }));
                },
                enumerable: true,
                configurable: true
            },
            /** Appended to the success toast when unsupported assets were skipped; pluralized by skipped count. */
            unsupportedSkipped: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (skippedCount: number) => __intl__.intl().formatMessage({ id: "useUbsValidationAction.unsupportedSkipped?c=2yo5ge9j6zs35", defaultMessage: "{skippedCount, plural, one {{skippedCount} unsupported file was skipped.} other {{skippedCount} unsupported files were skipped.}}" }, { skippedCount: skippedCount }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message shown when the selection exceeds the supported limit for UBS validation. */
            tooManySelectedText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useUbsValidationAction.tooManySelectedText?c=3hlw9v01jya4y", defaultMessage: "UBS validation can be applied to up to 100 assets at a time." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message shown when we fail to start UBS validation. */
            errorStartingText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useUbsValidationAction.errorStartingText?c=2vjd076q6i97a", defaultMessage: "There was an error starting the UBS validation." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message shown when no selected files match the supported formats. */
            noSupportedFilesText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useUbsValidationAction.noSupportedFilesText?c=ka82gqjqvf1y", defaultMessage: "None of the selected files have a supported format." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
